import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamMemberActions, IThunkGetClinicMembers } from '../types';

const onGetClinicMembers: IThunkGetClinicMembers = thunk(
  async ({ setClinicMembers }: Actions<IActTeamMemberActions>, payload) => {
    const { clinicId, teamIds } = payload;

    const { data } = await api.actTeamMember.getClinicMembers(clinicId, teamIds);

    setClinicMembers(data);
  },
);

export default onGetClinicMembers;
